export default __webpack_public_path__ + "static/digi_workflow-d0a664bd0e07736a741cebaeff929f4b.webp";